import { Component, Input, Output, EventEmitter } from '@angular/core';
import { RouteProvider } from '../../providers/route/route';

@Component({
  selector: 'rmt-list-item-new',
  templateUrl: 'rmt-list-item-new.html'
})
export class RmtListItemNewComponent {

  @Input() private title = '';
  @Input() isCollapsibleText = false;
  @Input() isHtmlTitle: boolean = false;
  @Input() ribbons: any[] = [];
  @Input() leftText = '';
  @Input() rightText = '';
  @Input() titleStyle = '';
  @Input() imgStyle: string;
  @Input() subtitle1Style = '';
  @Input() greyedOut: boolean;
  @Input() disable: boolean;
  @Input() isSelected: boolean = false;
  @Input() selectorEnabled: boolean = true;
  @Input() noImg: boolean = false;
  @Input() isBankSelected: boolean = false;
  @Input() isSubtitle2: boolean = false;
  @Input() subTitle2Style: string;
  @Input() isDisabledImg: boolean = false;
  @Input() disableImgBackground: boolean = false;
  @Input() badgeText;
  @Input() badgeStyle;

  @Input() private subtitleItem: string;
  @Input() private subtitle1: string;
  @Input() private subtitle1Loading: boolean;
  @Input() private titleHeader: string;
  @Input() private showTitleHeader: boolean = true;

  @Input() private titleHeaderStyle: string;
  @Input() private subtitleRateText: string;
  @Input() private subtitleRateValueFrom: string = '';
  @Input() private subtitleRateValueTo: string = '';
  @Input() private subtitleActivityAmount: string;
  @Input() private subtitleActivityStatus: string;
  @Input() private subtitleActivityColor: string;
  @Input() private description: string;
  @Input() private buttonType: string = '';
  @Input() private subtitle2Text: string = '';
  @Input() private tooltipEnabled: boolean = false;
  @Input() private dateShown: string = '';
  @Input() private loadingStatus: boolean = false;

  @Input() private labels: any[];

  //@Input() private buttonType: string = 'chevron';

  @Input() private img: string = 'assets/icons/bank_delivery.svg';
  @Input() private border: boolean = true;
  @Input() private first: boolean = false;
  @Input() private promo: any;
  @Input() private customId: any;
  @Input() private initials: any;
  @Input() private color: any;
  @Input() private smallImg: any;
  @Input() private canShowBubble: boolean = false;
  @Input() private bubbleText: string = '';
  @Output() itemEmitter = new EventEmitter();
  @Output() buttonEmitter = new EventEmitter();
  @Output() labelEmitter = new EventEmitter();

  static colorMap = ['green', 'red', 'yellow', 'blue', 'purple', 'pink'];

  thumbnailCssClass = '';
  itemTextCssClass = '';
  collapsibleTextCssClass = '';

  constructor(private routeProvider: RouteProvider) { }

  ngOnInit(){ // using var not function on html make the function call happen one time not repeating  
    this.thumbnailCssClass = this.getIonThumbnailCssClass();
    this.itemTextCssClass = this.getItemTextCssClass();
    if (this.isCollapsibleText) {
      this.collapsibleTextCssClass = this.getCollapsibleTextCssClass();
    }
  }

  action() {
  }

  emit() {
    if (this.disable) return; // to make no action when click 
    this.itemEmitter.emit('');
  }

  emitLabel(label) {
    if (this.disable) return;
    this.labelEmitter.emit(label);
  }

  emitButton(event) {
    if (this.disable) return;// to make no action when click 
    this.buttonEmitter.emit(event);
  }

  presentTooltip(event) {
    event.stopPropagation();
    const brandIcons = ['logo_marianos.svg', 'logo_dillons.svg', 'logo_metro_market.svg', 'logo_fred_meyer.svg', 'logo_pay_less.svg', 'logo_bakers.svg',
      'logo_city_market.svg', 'logo_copps.svg', 'logo_king_soopers.svg', 'logo_kroger.svg', 'logo_frys.svg', 'logo_picknsave.svg', 'logo_gerbes.svg', 'logo_qfc.svg',
      'logo_harris_teeter.svg', 'logo_smiths.svg', 'logo_jayc.svg'];
    this.routeProvider.openModal(this.routeProvider.pages.StagedRiaBrandingPage, { brandIcons: brandIcons }, null, 'staging-brand-details-modal');
    return;
  }

  getIonThumbnailCssClass() {
    if(this.isSelected)
     return 'thumbnail-icon-bg'
    if (!this.disable) {
      if (this.greyedOut)
        return 'greyed-out';
      else return '';
    } else {
      if (this.greyedOut)
        return 'greyed-out disable-item';
      else return 'disable-item';
    }
  }

  getCollapsibleTextCssClass() {
    if (!this.disable) {
      if (this.greyedOut)
        return 'greyed-out';
      else return '';
    } else {
      if (this.greyedOut)
        return 'disable-item greyed-out';
      else return 'disable-item';
    }
  }

  getItemTextCssClass() {
    if (this.titleStyle) {
      return this.titleStyle;
    }
    if (!this.disable) {
      if (this.greyedOut)
        return 'rmt-font Body1 semibold no-margin ellipsis greyed-out';
      else return 'rmt-font Body1 semibold no-margin ellipsis';
    } else {
      if (this.greyedOut)
        return 'disable-item rmt-font Body1 semibold no-margin ellipsis greyed-out';
      else return 'disable-item rmt-font Body1 semibold no-margin ellipsis';
    }
  }

  getCustomRowClass() {
    let rowClass = "";
    if (this.buttonType === 'radio') {
      rowClass += " radio";
      if (this.isSelected || this.isBankSelected) {
        rowClass += " radio-selected";
      }
    } else if (this.isSelected || this.isBankSelected) {
      rowClass += " selected";
    }
    if (this.imgStyle === 'medium') {
      rowClass += " medium-icon";
    }
    if (this.imgStyle === 'large') {
      rowClass += " large-icon";
    }
    if (this.imgStyle === 'new') {
      rowClass += " new-icon";
    }
    if (this.disableImgBackground) {
      rowClass += " disable-icon-background";
    }
    if (this.imgStyle != 'large' && this.imgStyle != 'new') {
      rowClass += " small-icon";
    }
    return rowClass.trim();
  }

  getSelectorOpacity() {
    if (this.selectorEnabled) return '100%'
    return '40%'
  }
  
}



// WEBPACK FOOTER //
// ./src/components/rmt-list-item-new/rmt-list-item-new.ts